import React from 'react'
import darkLogo from '../assets/logo-dark.svg'
import whiteLogo from '../assets/Noveliatech - Logo - White.svg'
import logoWhiteSymbol from "../assets/Noveliatech - Symbol - White.svg"

const Logo = ({ isWhite }) => {

  return (
    <a href='/' className='text-decoration-none'>
      {isWhite ? (
<>
        <img src={whiteLogo} alt='Logo' width="70%" height="70%" className='d-none d-lg-inline-block'/>
        <img src={logoWhiteSymbol} alt='Logo' width="70%" height="70%" className='d-inline-block d-lg-none'/>
</>
      ) : (
        <img src={darkLogo} alt='Logo' width="80%" height="80%" />
      )}
    </a>
  )
}
export default Logo
